export default "__VITE_ASSET__gQRrbMi9__"